export enum XhrWorkerEvent {
	ABORT = 'abort',
	DESTROY = 'destroy',
	ERROR = 'error',
	LOAD = 'load',
	PROGRESS = 'progress',
	SUCCESS = 'success',
	TIMEOUT = 'timeout'
}
